import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';

/**
 * Generated class for the MessaggioPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-messaggio',
  templateUrl: 'messaggio.html',
})
export class MessaggioPage {
tot;
oggi;
sms;
errorMessage;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,
    ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MessaggioPage');
    this.getCodiceTot();
    this.getCodiceOggi();
    this.getSms();
  }
  getCodiceTot() {
    this.rest.getCodiceTot()
      .subscribe(
        tot =>{
          this.tot = tot;
          console.log("codiceTot:" + this.tot);

        } ,
        error => this.errorMessage = <any>error);

  }
  getCodiceOggi() {
    this.rest.getCodiceOggi()
      .subscribe(
        oggi =>{
          this.oggi = oggi;
          console.log("codiceOggi:" + this.oggi);
          if(JSON.stringify(oggi).match("{}"))
          {this.oggi=0;}
        //  alert(JSON.stringify(oggi))
        } ,
        error => this.errorMessage = <any>error);

  }
  getSms() {
    this.rest.getSms()
      .subscribe(
        sms =>{
          this.sms = sms;
       //  alert( JSON.stringify(this.sms));

        } ,
        error => this.errorMessage = <any>error);

  }
}



// WEBPACK FOOTER //
// ./src/pages/messaggio/messaggio.ts